/**
 * Ends CPL tracking
 * @param {String} identifier for identifying which recordCplStart to end
 * @param {Object} data object containing additional data to track
 */
export function recordCplEnd(identifier, data) {
  data = data || {}
  try {
    if (identifier) window.PAYPAL.analytics.endCPLTracking(data, identifier)
    else window.PAYPAL.analytics.endCPLTracking(data)
  } catch {
    return
  }
}
